import * as React from 'react';
import { LoadingState } from '@/components/common/LoadingState';

/**
 * Canonical <Suspense> fallback. Unifies the three loaders that used to
 * coexist (inline-hex PageLoader, `Skeleton h-96`, ad-hoc `Loader2`).
 *
 *   <Suspense fallback={<RouteFallback full label="Cargando módulo…" />}>  // route-level
 *   <Suspense fallback={<RouteFallback />}>                                 // tab-level
 */
interface RouteFallbackProps {
  /** Route-level height (min-h 60vh). Omit for compact tab-level height. */
  full?: boolean;
  label?: string;
}

export function RouteFallback({ full = false, label }: RouteFallbackProps) {
  if (full) return <LoadingState label={label} />;
  return (
    <div className="flex items-center justify-center py-12">
      <LoadingState variant="inline" label={label} />
    </div>
  );
}
